/* The Paper Temple — theme behavior: portal gate + AJAX cart drawer */
(function () {
  'use strict';
  var body = document.body;

  /* ---------------- PORTAL GATE ---------------- */
  var gate = document.getElementById('gate');
  var portalLoad = document.getElementById('portalLoad');
  var enterBtn = document.getElementById('enterBtn');

  function enter() {
    if (body.classList.contains('entering')) return;
    body.classList.add('entering');
    // Remember in both: sessionStorage covers this tab, localStorage means coming
    // home later (or in a new tab) lands on the shop, not the gate again.
    try { sessionStorage.setItem('enteredTemple', '1'); } catch (e) {}
    try { localStorage.setItem('enteredTemple', '1'); } catch (e) {}
    if (portalLoad) setTimeout(function () { portalLoad.classList.add('show'); }, 550);
    setTimeout(function () { body.classList.add('entered'); if (gate) gate.style.display = 'none'; }, 1500);
    if (portalLoad) setTimeout(function () { portalLoad.classList.remove('show'); }, 2150);
  }
  if (enterBtn) enterBtn.addEventListener('click', enter);
  // skip the gate for anyone who has already walked through it. The inline script in
  // <head> has usually done this before paint; this is the belt-and-braces pass.
  if (gate && document.documentElement.classList.contains('entered')) {
    gate.style.display = 'none';
    body.classList.add('entered');
  }

  /* ---------------- CART DRAWER ---------------- */
  var drawer = document.getElementById('drawer');
  var scrim = document.getElementById('scrim');
  var drawerBody = document.getElementById('drawerBody');
  var cartBtn = document.getElementById('cartBtn');
  var closeBtn = document.getElementById('closeCart');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var routes = window.routes || {};
  var moneyFormat = (drawerBody && drawerBody.getAttribute('data-money-format')) || '${{amount}}';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Shopify CDN urls take a ?width= param — ask for a thumbnail, not the full image
  function thumb(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, value)
                      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function openCart() { if (drawer) { drawer.classList.add('open'); scrim.classList.add('open'); } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); scrim.classList.remove('open'); } }
  if (cartBtn && window.cartType === 'drawer') cartBtn.addEventListener('click', function (e) { e.preventDefault(); openCart(); renderCart(); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (scrim) scrim.addEventListener('click', closeCart);

  function setCount(n) {
    countEls.forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
  }

  function renderCart() {
    if (!drawerBody) return;
    fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (!cart.items.length) {
          drawerBody.innerHTML =
            '<div class="script">' + esc(window.cartEmptyText || 'no treasures yet') + '</div>' +
            '<p style="font-size:12px;letter-spacing:.05em">' +
              '<a href="' + (routes.shop_url || '/collections/all') + '" style="color:var(--accent)">' +
                esc(window.cartEmptyLinkText || 'go find some…') + ' &rarr;</a></p>';
          drawerBody.style.justifyContent = 'center';
          return;
        }
        drawerBody.style.justifyContent = 'flex-start';
        var h = '<div style="padding:16px;display:flex;flex-direction:column;gap:2px;width:100%">';
        cart.items.forEach(function (it) {
          var img = it.image || (it.featured_image && it.featured_image.url);
          h += '<div class="cart-line" data-key="' + esc(it.key) + '">' +
                 '<a class="ci-img" href="' + esc(it.url || '#') + '">' +
                   (img
                     ? '<img src="' + esc(thumb(img, 160)) + '" alt="' + esc(it.product_title) + '" loading="lazy">'
                     : '') +
                 '</a>' +
                 '<span class="ci-name">' + esc(it.product_title) +
                   ' <span class="ci-qty">&times;' + it.quantity + '</span></span>' +
                 '<span class="ci-price">' + formatMoney(it.final_line_price) + '</span>' +
                 '<button type="button" class="ci-remove" data-remove="' + esc(it.key) + '"' +
                   ' aria-label="Remove ' + esc(it.product_title) + '">&times;</button>' +
               '</div>';
        });
        h += '</div><div class="cart-foot">' +
               '<div class="cart-sub"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
               '<button class="cart-checkout" onclick="window.location.href=\'/checkout\'">Checkout</button>' +
               '<p class="cart-note">shipping &amp; taxes handled by Shopify</p>' +
             '</div>';
        drawerBody.innerHTML = h;
      })
      .catch(function () {});
  }

  /* Show an add-to-cart failure next to the button instead of silently
     opening an empty basket. Shopify returns 4xx + {description|message}
     when a variant can't be sold (draft product, out of stock, not on the
     Online Store channel, …). */
  function showAddError(btn, msg) {
    if (!btn) { window.alert(msg); return; }
    var host = btn.parentNode;
    var note = host.querySelector('.add-error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'add-error';
      note.setAttribute('role', 'alert');
      host.appendChild(note);
    }
    note.textContent = msg;
    clearTimeout(note._t);
    note._t = setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 6000);
  }

  function addToCart(variantId, qty, btn) {
    if (btn) { btn.disabled = true; }
    var failed = false;
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) {
        failed = !r.ok;
        return r.json().catch(function () { return {}; });
      })
      .then(function (data) {
        if (btn) btn.disabled = false;
        if (failed) {
          showAddError(btn, data.description || data.message ||
            "Sorry — this one can't be added right now.");
          return;
        }
        if (window.cartType === 'drawer') { renderCart(); openCart(); }
        else { window.location.href = routes.cart_url; }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        showAddError(btn, 'Something went wrong — please try again.');
      });
  }

  function removeLine(key) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { renderCart(); }).catch(function () {});
  }

  // any element with data-add-to-cart="<variantId>" adds on click
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); removeLine(rm.getAttribute('data-remove')); return; }
    var el = e.target.closest('[data-add-to-cart]');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = el.getAttribute('data-add-to-cart');
    if (vid) addToCart(vid, 1, el);
  });

  // populate the count on load
  renderCart();
})();
